// Shared RNI text parser (used by titular form and family member mini-form)
// Format: RUT\t\tNOMBRES\tPRIMER_APELLIDO\tSEGUNDO_APELLIDO\tFECHA_NACIMIENTO
export function parseRniText(texto) {
  if (!texto || !texto.trim()) return null;

  const datosExtraidos = {};
  const partes = texto.trim().split(/\t+/);

  if (partes.length >= 5) {
    let rut = partes[0].trim();
    if (rut && !rut.includes('-') && rut.length >= 8) {
      rut = rut.slice(0, -1) + '-' + rut.slice(-1);
    }
    if (rut) datosExtraidos.rut = rut.toUpperCase();

    if (partes[1] && partes[1].trim()) datosExtraidos.nombres = partes[1].trim().toUpperCase();
    if (partes[2] && partes[2].trim()) datosExtraidos.primer_apellido = partes[2].trim().toUpperCase();
    if (partes[3] && partes[3].trim()) datosExtraidos.segundo_apellido = partes[3].trim().toUpperCase();

    if (partes[4] && partes[4].trim()) {
      let fecha = partes[4].trim();
      if (fecha.match(/^\d{2}[-\/]\d{2}[-\/]\d{4}$/)) {
        const separator = fecha.includes('/') ? '/' : '-';
        const p = fecha.split(separator);
        fecha = `${p[2]}-${p[1]}-${p[0]}`;
      }
      datosExtraidos.fecha_nacimiento = fecha;
    }
  } else {
    // Fallback: parse free-form text
    const allText = texto.replace(/\n/g, ' ').replace(/\t+/g, ' ');

    const rutMatch = allText.match(/(\d{7,9}-?[\dkK])/i);
    if (rutMatch) {
      let rut = rutMatch[1];
      if (!rut.includes('-') && rut.length >= 8) {
        rut = rut.slice(0, -1) + '-' + rut.slice(-1);
      }
      datosExtraidos.rut = rut.toUpperCase();
    }

    const dateMatch = allText.match(/(\d{2}[\/\-]\d{2}[\/\-]\d{4})/);
    if (dateMatch) {
      let fecha = dateMatch[0];
      const separator = fecha.includes('/') ? '/' : '-';
      const p = fecha.split(separator);
      if (p[0].length === 2) {
        fecha = `${p[2]}-${p[1]}-${p[0]}`;
      }
      datosExtraidos.fecha_nacimiento = fecha;
    }

    let nombresText = allText;
    if (rutMatch) nombresText = nombresText.replace(rutMatch[0], '');
    if (dateMatch) nombresText = nombresText.replace(dateMatch[0], '');

    const palabras = nombresText.trim().split(/\s+/).filter(p => p.length > 1 && /^[A-ZÁÉÍÓÚÑ]+$/i.test(p));
    if (palabras.length >= 3) {
      datosExtraidos.segundo_apellido = palabras.pop().toUpperCase();
      datosExtraidos.primer_apellido = palabras.pop().toUpperCase();
      datosExtraidos.nombres = palabras.join(' ').toUpperCase();
    } else if (palabras.length === 2) {
      datosExtraidos.primer_apellido = palabras[1].toUpperCase();
      datosExtraidos.nombres = palabras[0].toUpperCase();
    }
  }

  return datosExtraidos;
}
